// File: src/nba/EditStepDialog.tsx

import React, { useState, useEffect } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField
} from '@material-ui/core';
import { Step } from './types';

interface EditStepDialogProps {
  open: boolean;
  onClose: () => void;
  onSave: (step: Step) => void;
  step: Step | null;
}

const emptyStep: Omit<Step, 'id' | 'actions'> = {
  name: '',
  clientId: '',
  order: 0,
};

export const EditStepDialog: React.FC<EditStepDialogProps> = ({ open, onClose, onSave, step }) => {
  const [formData, setFormData] = useState(emptyStep);

  useEffect(() => {
    if (step) {
      setFormData({
        name: step.name,
        clientId: step.clientId,
        order: step.order ?? 0,
      });
    } else {
      setFormData(emptyStep);
    }
  }, [step, open]);

  const handleChange = (name: keyof typeof emptyStep, value: any) => {
    setFormData(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSave = () => {
    onSave({
      ...formData,
      id: step?.id || '', // Preserve existing id
      actions: step?.actions || [], // Preserve existing actions
    });
    onClose();
  };

  return (
    <Dialog
      fullWidth
      maxWidth="sm"
      open={open}
      onClose={onClose}
    >
      <DialogTitle>
        {step ? 'Edit Step' : 'Create Step'}
      </DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          fullWidth
          label="Step Name"
          margin="normal"
          name="name"
          value={formData.name}
          onChange={(e) => handleChange('name', e.target.value)}
        />
        <TextField
          fullWidth
          label="Order"
          margin="normal"
          name="order"
          type="number"
          value={formData.order}
          onChange={(e) => handleChange('order', Number(e.target.value))}
        />
      </DialogContent>
      <DialogActions>
        <Button
          color="primary"
          onClick={onClose}
        >
          Cancel
        </Button>
        <Button
          color="primary"
          variant="contained"
          onClick={handleSave}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};